import React, { Component, useEffect, useState } from 'react';
import {connect} from 'react-redux';
import {Helmet} from "react-helmet";
import {bindActionCreators} from 'redux';
import {getGoals, getGoalQuestions, verifyPAN, cleanGoalsContent, verifyKYC, encryptRSA, decryptAES, encryptAES, forceLogout, cleanAuthContent} from '../../actions';
import Input from "../../../../general/Input";
import DatePicker from "../../../../general/DatePicker";
import {closePopup, openPopup} from "../../../../general/Modal/action";
import NoContent from "../../../../general/NoContent";
import {MODALS} from "../../../../general/Modal/constants";
import "./style.scss";
import moment from "moment";
import cookie from 'react-cookies';

const Authentication = (props) => {

    const {authValues, verifyKYC, closePopup, openPopup, forceLogout, investmentBasket, journey, setJourneyPage, cleanAuthContent, onClick, resetGoalData, goalPlanningName} = props;

    const [values, setValues] = useState({
        pan: authValues.pan,
        dob: authValues.dob,
    });
    const [tempValues, setTempValues] = useState({
        mobile: '',
        email: '',
    });
    const [error, setError] = useState({
        pan: '',
        dob: '',
        mobile: '',
        email: '',
        activeUser: '',
    })
    const [nextDisabled, setNextDisabled] = useState(true);
    const [noMail, setNoMail] = useState(false);
    const [noNumber, setNoNumber] = useState(false);
    const [kycVerificationResponse, setKycVerificationResponse] = useState({});
    const [taxStatusName, settaxStatusName] = useState('RI');
    const [taxStatusValue, settaxStatusValue] = useState(false);

    const okAction = () => {
        setJourneyPage(0);
    }
    
    useEffect(()=>{
        handleTaxStatus(taxStatusName);
        let scrollToElement = require('scroll-to-element');
            scrollToElement(document.querySelector(".invest-smart"), {
                ease: 'linear',
                duration: 100,
        });
    },[]);

    useEffect(()=>{
        if((typeof values.dob !== "object" || !values.pan || error.pan)){
            setNextDisabled(true)
        }
        else {
            setNextDisabled(false);
            const functionTest = async() => {
                let data = {
                    encdob: encryptRSA(moment(values.dob).format("DD-MMM-YYYY")),
                    panNumber: encryptRSA(values.pan.toUpperCase()),
                    nriFlag : taxStatusValue
                }
                // console.log((JSON.stringify(data)));
                const response = await verifyKYC(encryptAES(JSON.stringify(data)));
                response && setKycVerificationResponse(response);
            }
            functionTest();
        }
    },[values]);

    useEffect(()=>{
        if(noMail){
            !tempValues.email.length && setNextDisabled(true);
        }
        else setNextDisabled(false);
    }, [noMail, noNumber]);

    useEffect(()=>{
        if((error.pan || error.dob || error.mobile || error.activeUser || error.email || error.mobile)){
            setNextDisabled(true);
        }
        else if((typeof values.dob !== "object" || !values.pan || (noMail && !tempValues.email.length))){
            setNextDisabled(true);
        }
        else setNextDisabled(false);
    },[error]);

    useEffect(() => {
        if(investmentBasket.kycVerificationData && investmentBasket.kycVerificationData.apiLoaded && investmentBasket.kycVerificationData.message && investmentBasket.kycVerificationData.message.includes("active")){
            setError(currentValue => ({
                ...currentValue,
                activeUser: investmentBasket.kycVerificationData.message,
            }));
        }
        else {
            setError(currentValue => ({
                ...currentValue,
                activeUser: '',
            }));
        }
        if(investmentBasket.kycVerificationData && investmentBasket.kycVerificationData.apiLoaded && investmentBasket.kycVerificationData.popupEnabled){
            let modalData={
                modalClass: 'error-modal',
                message:investmentBasket.kycVerificationData.message,
                okAction: okAction,
                cleanAuthContent:cleanAuthContent,
            }
            if(onClick){
                modalData["onClick"] = onClick;
            }
            if(resetGoalData){
                modalData["resetGoalData"] = resetGoalData;
            }
            openPopup(MODALS.ERROR_MODAL_ECART, modalData)
        }
        if(investmentBasket.kycVerificationData && investmentBasket.kycVerificationData.apiLoaded &&  investmentBasket.kycVerificationData.data && !investmentBasket.kycVerificationData.data.maskedEmail){
            setNoMail(true);
        } else setNoMail(false);
        if(investmentBasket.kycVerificationData && investmentBasket.kycVerificationData.apiLoaded &&  investmentBasket.kycVerificationData.data && !investmentBasket.kycVerificationData.data.maskedMobile){
            setNoNumber(true);
        } else setNoNumber(false);
        if(investmentBasket.kycVerificationData && investmentBasket.kycVerificationData.apiLoaded && investmentBasket.kycVerificationData && investmentBasket.kycVerificationData.message && investmentBasket.kycVerificationData.message.includes("invalid")){
            setError(currentValue => ({
                ...currentValue,
                dob: investmentBasket.kycVerificationData.message,
            }));
        }
        if(investmentBasket.kycVerificationData && investmentBasket.kycVerificationData.apiLoaded && !investmentBasket.kycVerificationData.data && investmentBasket.kycVerificationData.message){
            setError(currentValue => ({
                ...currentValue,
                dob: investmentBasket.kycVerificationData.message,
            }));
        }
        else {
            if(investmentBasket.kycVerificationData && investmentBasket.kycVerificationData.apiLoaded && investmentBasket.kycVerificationData.data && investmentBasket.kycVerificationData.data.kycVerifiedFlag){
                onSubmit();
            }
            setError(currentValue => ({
                ...currentValue,
                dob: '',
            }));
        }
    },[investmentBasket.kycVerificationData]);

    useEffect(() => {
        let payloadForForceLogout = {
            panNumber: values.pan.toUpperCase(),
        }
        let payloadForVerifyKyc = {
            encdob: encryptRSA(moment(values.dob).format("DD-MMM-YYYY")),
            panNumber: encryptRSA(values.pan.toUpperCase()),
        }
        if(error.activeUser){
            let modalData = {
                modalClass: 'force-logout-modal',
                payloadForForceLogout: encryptAES(JSON.stringify(payloadForForceLogout)),
                payloadForVerifyKyc: encryptAES(JSON.stringify(payloadForVerifyKyc)),
                forceLogout: forceLogout,
                verifyKYC: verifyKYC,
            }
            openPopup(MODALS.FORCE_LOGOUT, modalData)
        }
    }, [error.activeUser]);

    const onChange = (name, value) => {
        if((name === 'dob') || (name === 'pan')){
            setValues(currentValue => ({
                ...currentValue,
                [name]: name === 'pan' ? value.toUpperCase(): value,
            }));
        }
        else {
            setTempValues(currentValue => ({
                ...currentValue,
                [name]: value,
            }));
        }
        let payloadForForceLogout = {
            panNumber: values.pan.toUpperCase(),
        }
        let payloadForVerifyKyc = {
            encdob: encryptRSA(moment(values.dob).format("DD-MMM-YYYY")),
            panNumber: encryptRSA(values.pan.toUpperCase()),
        }
        if(error.activeUser){
            let modalData = {
                modalClass: 'force-logout-modal',
                payloadForForceLogout: encryptAES(JSON.stringify(payloadForForceLogout)),
                payloadForVerifyKyc: encryptAES(JSON.stringify(payloadForVerifyKyc)),
                forceLogout: forceLogout,
                verifyKYC: verifyKYC,
            }
            openPopup(MODALS.FORCE_LOGOUT, modalData)
        }validateChange(name, value);
        name === 'dob' && console.log((moment().diff(value, 'years')));
    }

    const validateChange = (name, value) => {
        if(value.length !== 0) {
            switch (name){
                case 'pan' :
                    if((/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(value)) && (value.charAt(3) === 'P')) {
                        setError(currentValue => ({
                            ...currentValue,
                            [name]: '',
                        }));
                    }
                    else{
                        setError(currentValue => ({
                            ...currentValue,
                            [name]: 'Please enter valid PAN.',
                        }));
                    }
                    break;
                case 'mobile' :
                    if(/^[1-9]{1}[0-9]{9}$/.test(value)) {
                        setError(currentValue => ({
                            ...currentValue,
                            [name]: '',
                        }));
                    }
                    else {
                        setError(currentValue => ({
                            ...currentValue,
                            [name]: 'Invalid Mobile Number!',
                        }));
                    }
                    break;
                case 'dob' :
                    if((moment().diff(value, 'years')) > 17) {
                            setError(currentValue => ({
                                ...currentValue,
                                [name]: '',
                            }));
                    }
                    else {
                        setError(currentValue => ({
                        ...currentValue,
                        [name]: `Applicant's age should be 18 years or above`,
                        }));
                    }
                    break;
                case 'email':
                    if(/[A-Za-z0-9._%+-]+@[A-Za-z]+\.[a-zA-Z]{2,4}/.test(value)){
                        setError(currentValue => ({
                            ...currentValue,
                            [name]: '',
                        }));
                    } else {
                        setError(currentValue => ({
                            ...currentValue,
                            [name]: 'Invalid Email!',
                        }));
                    }
                    break;
                default:
                    setError(currentValue => ({
                        ...currentValue,
                    }));
            }
        }
        else {
            setError(currentValue => ({
                ...currentValue,
                [name]: '',
            }))
            setNextDisabled(true);
        }
    }

    const onSubmit = () => {
        const {onSubmit} = props;
        let valueObject = {...values,
                            ...tempValues }
        onSubmit(valueObject, investmentBasket.kycVerificationData);
    }

    const onBack = () => {
        const {onBack} = props;
        onBack();
    }
    const handleTaxStatus = (name) => {
        let taxValue = '';
        if(name == 'RI'){
            taxValue = false;
        } else if(name == 'NRI'){
            taxValue = true;
        }
        settaxStatusValue(taxValue);
        settaxStatusName(name);
        cookie.save("taxData", taxValue, {path: "/"});
    }

    return (
        <div className="authentication">
            <p>{journey && journey === 'RISK_JOURNEY' ? 'You are one step away from knowing your investment personality!' : 'Take a step towards your goal!'}</p>
            {goalPlanningName != 'Children & Education' && <div className='taxcls'>
                <p>TAX Status</p>
                <div className='d-md-flex'>
                    <div className='form-check'>
                        <input
                            type="radio"
                            name="taxStatus"
                            value="RI"
                            checked = {taxStatusName == 'RI'}
                            onClick={()=>handleTaxStatus('RI')}
                        />
                        <label
                        className="form-check-label ms-2"
                        for="taxStatus"
                        >
                        Resident indiviual
                        </label>
                    </div>
                    <div className='form-check'>
                        <input
                            type="radio"
                            name="taxStatus"
                            value="NRI"
                            checked = {taxStatusName == 'NRI'}
                            onClick={()=>handleTaxStatus('NRI')}

                        />
                        <label
                        className="form-check-label ms-2"
                        for="taxStatus"
                        >Non-Resident indiviual</label>
                    </div>
                </div>
            </div>}
            <div className="pan-input">
                <Input
                    name='pan'
                    placeHolder='Enter your PAN number'
                    value={values.pan.toUpperCase()}
                    isAlphaNumeric
                    onChange={onChange}
                    maxLength={10}
                    errorMessage={error.pan}
                    // disableField={fieldDisabled}
                    labelName="PAN"
                    required
                />
            </div>
            <div className="dob-input">
                <label>DOB <span class="asterick">*</span></label>
                <DatePicker
                    name='dob'
                    selected={values.dob}
                    placeholderText="Enter your DOB"
                    dateFormat="DD/MMM/YYYY"
                    onChangeRaw={(e) => e.preventDefault()}                
                    showYearDropdown
                    showMonthDropdown
                    updateParent={onChange}
                    minDate={moment().subtract(99, "year")}
                    maxDate={moment()}
                    dropdownMode="select"
                />
                {investmentBasket.kycVerificationData && investmentBasket.kycVerificationData.apiLoaded && !investmentBasket.kycVerificationData.popupEnabled && error.dob && <div className="error-message">{error.dob}</div>}
            </div>              
            {noMail && <div className="email-input">
                <Input
                    name='email'
                    placeHolder='Email id'
                    value={tempValues.email}
                    onChange={onChange}
                    errorMessage={error.email}
                    labelName="Email"
                    required
                />
            </div>}
            {noNumber && <div className="email-input">
                <Input
                    name='mobile'
                    placeHolder='Mobile Number'
                    value={tempValues.mobile}
                    isNumeric
                    onChange={onChange}
                    maxLength={10}
                    errorMessage={error.mobile}
                    labelName="Mobile"
                    required
                />
            </div>}
            <div className="buttons">              
                <button onClick={onBack} className='back submit'>Back</button>
                {investmentBasket.kycVerificationData && investmentBasket.kycVerificationData.apiLoaded && investmentBasket.kycVerificationData.data && !investmentBasket.kycVerificationData.data.kycVerifiedFlag && <button onClick={onSubmit} className={nextDisabled ? 'disabled submit' : 'submit'} disabled={nextDisabled}>Submit</button>}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    commonContent: state.commonContent,
    investmentBasket: state.ProductSolution.home,
});

const mapDispatchToProps = (dispatch) => ({
    getGoals: bindActionCreators(getGoals, dispatch),
    getGoalQuestions: bindActionCreators(getGoalQuestions, dispatch),
    cleanGoalsContent: bindActionCreators(cleanGoalsContent, dispatch),
    verifyPAN: bindActionCreators(verifyPAN, dispatch),
    verifyKYC: bindActionCreators(verifyKYC, dispatch),
    forceLogout: bindActionCreators(forceLogout, dispatch),
    closePopup: bindActionCreators(closePopup, dispatch),
    openPopup: bindActionCreators(openPopup, dispatch),
    cleanAuthContent: bindActionCreators(cleanAuthContent, dispatch),
});

const AuthenticationContainer = connect(mapStateToProps, mapDispatchToProps)(Authentication);

export default AuthenticationContainer;